import Button from '@material-ui/core/Button'

import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => ({
	root: {
		margin: theme.spacing.unit,
		backgroundColor: "white",
	}
}))(Button)
